import React, { useState } from 'react';
import { MetaTags } from 'react-meta-tags';
//import Breadcrumbs
import { DashBreadcrumb } from '../../../components/Common/Breadcrumb';
import 'react-drawer/lib/react-drawer.css';
import { Col, Container, Row } from 'reactstrap';
import { Toaster } from 'react-hot-toast';
import ServiceFeedbackList from './components/ServiceFeedbackList';

const ServiceFeedback = () => {
  const [refreshList, setRefreshList] = useState(false);

  return (
    <React.Fragment>
      <div className="page-content refundOrder">
        <MetaTags>
          <title>Service Feedback</title>
        </MetaTags>
        <Container fluid>
          {/* Render Breadcrumbs */}
          <Row className="align-items-center">
            <Col xl={4}>
              <DashBreadcrumb
                title="Service Orders"
                breadcrumbItem="Service Feedback"
              />
            </Col>
            <Col xl={8}>
              <div className="d-flex justify-content-end align-items-center flex-wrap gap-2 mb-3">
                <button
                  type="button"
                  className="btn btn-dark"
                  onClick={() => setRefreshList((prev) => !prev)}
                  style={{ whiteSpace: 'nowrap' }}
                >
                  <i className="mdi mdi-refresh me-1"></i>
                  Refresh
                </button>
              </div>
            </Col>
          </Row>
          <ServiceFeedbackList refreshList={refreshList} />
        </Container>
      </div>
      <Toaster position="top-right" reverseOrder={false} />
    </React.Fragment>
  );
};

export default ServiceFeedback;
